const items: string[] = [
  '#6CADBF',
  '#8CC9AB',
  '#B5D094',
  '#DFC283',
  '#DF8383',
  '#B794CB',
  '#9C94CB',
  '#8C9CC9',
  '#F1F1F1',
  '#645853',
]

export default items
